import { ROUTES } from '../routes/constants';

export const getDefaultUserRoute = (isBuyer: boolean) => (!isBuyer ? ROUTES.seller.dashboard._ : ROUTES.buyer._);
